import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatListAccess } from './format'

export function newAccess(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_ACCESS_START", payload: "" })
            console.log("new Access START", {data})
            const res = await axios.post('/users/access/new',{data})
            console.log({res});

            if(checkErrorData(res, "CREATE_ACCESS_ERROR", dispatch ) ) {
                let newData = Object.assign({}, res.data)
                newData.access_pages = newData.access_pages.split(", ")
                dispatch({ type: "NEW_ACCESS", payload: newData })
				dispatch({ type: "CREATE_ACCESS_FULFILLED", payload: "" })
            }
            
        } catch(err) {
            console.log("[ERROR] new access ", err);
            dispatch({
                type: "CREATE_ACCESS_ERROR",
                payload: err
            })
        }
    }
}

export function fetchAccess() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_ACCESS_START", payload: "" })

            console.log("fetch Access START")
            const res = await axios.get('/users/access/get/all')
            console.log({res});
            
            if(checkErrorData(res, "FETCH_ACCESS_ERROR", dispatch ) ) {
				dispatch({
                    type: "GET_ACCESS",
                    payload: formatListAccess(res.data, "access_id")
                })
				dispatch({ type: "FETCH_ACCESS_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] get access list ", err);
        }
    }
}


export function updateAccess(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_ACCESS_START", payload: "" })

            console.log("update Access START")
            const res = await axios.post("/users/access/update", {data})
            console.log({res});

            if(checkErrorData(res, "UPDATE_ACCESS_ERROR", dispatch ) ) {
                data.access_pages = data.access_pages.split(", ")
				dispatch({
                    type: "UPDATE_ACCESS",
                    payload: data
                })
				dispatch({ type: "UPDATE_ACCESS_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update access ", err);
            dispatch({
                type: "UPDATE_ACCESS_ERROR",
                payload: err
                
            })
        }
    }
}
export function deleteAccess(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_ACCESS_START", payload: "" })

            console.log("delete access START")
            const res = await axios.post("/users/access/delete", {data: data.access_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_ACCESS_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_ACCESS",
                    payload: data,
                })
                dispatch({ type: "DELETE_ACCESS_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete access ", err);
            dispatch({
                type: "DELETE_ACCESS_ERROR",
                payload: err
            })
        }
    }
}

